import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { targetAudience } from '../data/mock';

const TargetAudienceSection = () => {
  return (
    <section data-testid="target-audience-section" className="py-12 lg:py-20 relative">
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute bottom-0 left-1/4 w-[250px] h-[250px] bg-[#d987ff]/3 rounded-full blur-[100px]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-8 lg:mb-14">
          <h2 className="text-2xl lg:text-4xl font-bold mb-4 text-white">
            Für wen Northlight besonders <span className="text-gradient">interessant</span> ist
          </h2>
        </div>

        {/* Audience Grid */}
        <div className="grid md:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {targetAudience.map((item) => (
            <div
              key={item.id}
              data-testid={`audience-card-${item.id}`}
              className="group flex items-start gap-4 p-6 rounded-2xl bg-white/[0.02] border border-white/[0.06] transition-colors duration-200 hover:bg-white/[0.04] hover:border-white/[0.12]"
            >
              <div className="w-8 h-8 rounded-lg bg-[#ff84e4]/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <ArrowUpRight className="w-4 h-4 text-[#ff84e4]" />
              </div>
              <div>
                <h3 className="text-base font-semibold text-white mb-1">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-500">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TargetAudienceSection;
